import(/* webpackMode: "eager" */ "/app/src/app/tools/image-to-doc/page.tsx");
